import { fetchAddOfferToComparison } from '../../shared/repositories/offers-comparison/v2/add-offer-to-comparison';
import { EComparisonNotificationCategory } from '../../types/comparison';
import { assertBadHttpStatus } from './assert/assertBadHttpStatus';
export async function addToComparison(_ref) {
  let {
    httpApi,
    logger,
    params
  } = _ref;
  try {
    const response = await fetchAddOfferToComparison({
      httpApi,
      parameters: params
    });
    assertBadHttpStatus(response);
    const {
      success,
      text,
      comparisonUrl,
      offerId
    } = response.response;
    return {
      text,
      url: comparisonUrl,
      category: success ? EComparisonNotificationCategory.Add : EComparisonNotificationCategory.Limit,
      offerId
    };
  } catch (error) {
    logger.error(error, {
      offerId: params.offerId,
      domain: 'addToComparison'
    });
  }
  return null;
}